export default __webpack_public_path__ + "84870547cf1536455834cc9d7fddfe21.svg";